export default "__VITE_ASSET__DowVUOBx__"